




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BorderType } from '@/models';

@Component({})
export default class SBProBorder extends Vue {
    @Prop() private borderType!: BorderType;
    @Prop() private borderClasses!: string;
}
